import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import OffBoardedUsersAuditTable from "./OffBoardedUsersAuditTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const OffboardedUsersAudit = (props) => {
  const classes = useStyles();
  console.log("ROLES HERE", authObj.roles);

  const [dataObj, setDataObj] = useState({
    offBoardedUsers: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/OffBoardedUserAudit/")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          offBoardedUsers: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <OffBoardedUsersAuditTable data={dataObj.offBoardedUsers} />
        </div>
      )}
    </>
  );
};

export default OffboardedUsersAudit;
